"use client";

import { usePathname } from 'next/navigation';
import { useCompetitionContext } from "./providers/CompetitionContext";
import { useState, useEffect } from 'react';

import { SquareX } from 'lucide-react'
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'

export default function NavMenu() { 
  const { brand } = useCompetitionContext();
  const pathname = usePathname();
  const [userId, setUserId] = useState<string | null>(null);
  const [teamId, setTeamId] = useState<string | null>(null);

  // Read teamId from cookie on client side
  useEffect(() => {
    const getCookieValue = (name: string): string | null => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        const popped = parts.pop();
        return popped ? popped.split(';').shift() || null : null;
      }
      return null;
    };

    // Check for authentication WONT WORK ON FRONTEND DPG COOKIE
    // const dpgAt = getCookieValue('dpg-component-at');
    // const dpgUit = getCookieValue('dpg-component-uit');
    // setIsAuthenticated(!!(dpgAt || dpgUit));

    const userId = getCookieValue('userInfo');
    if (userId) {
      setUserId(userId);
    }

    // Get teamId from cookie
    const teamIdFromCookie = getCookieValue('teamId');
    if (teamIdFromCookie && teamIdFromCookie !== '') {
      setTeamId(teamIdFromCookie);
    }
    console.log('teamIdFromCookie', teamIdFromCookie);

  }, []);

  // Base navigation items
  let navigation = [
    { name: 'Klassement', href: '/fantasy/rankings', current: false },
    // { name: 'Stats', href: '/stats', current: false },
    { name: 'Kalender', href: '/fantasy/calendar', current: false },
    { name: 'Prijzen', href: '/prizes', current: false },
    { name: 'Spelregels', href: '/rules', current: false },
  ].map(item => ({
    ...item,
    current: pathname === item.href
  }));

  // Dynamic navigation based on authentication and team status    
  if(userId) {
    const fantasyUrl = teamId ? `/fantasy/edit/${teamId}` : '/fantasy/new';

    navigation = [
      { 
        name: 'Spel', 
        href: fantasyUrl, 
        current: pathname === fantasyUrl || pathname.startsWith(`/fantasy/edit/`) 
      },
      ...navigation
    ]

    if (teamId) {
      navigation.splice(1, 0, { 
        name: 'Leagues', 
        href: '/fantasy/leagues', 
        current: pathname === '/fantasy/leagues' 
      });
    }
  }
  
  function classNames(...classes: any) {
    return classes.filter(Boolean).join(' ')
  }

  return (
    <Disclosure as="nav" className={`bg-${brand}-header`}>
      <div className="container max-w-[1140px] mx-auto max-w-7xl">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
          <div className="flex flex-row items-center gap-0 shrink-0">
              <a href={`https://${brand}.nl`} className="block">
                <img 
                  src={`https://dpgnl.s3.eu-west-1.amazonaws.com/files/${brand}.svg`} 
                  className="h-14 w-auto" 
                  alt={`${brand} Logo`}
                />
              </a>
              <a href="/" className="block">
                <img
                  src="https://dpgnl.s3.eu-west-1.amazonaws.com/files/logo-klas.svg"
                  className="h-14 w-auto"
                  alt="Logo Klassiekerspel"
                />
              </a>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-4">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    aria-current={item.current ? 'page' : undefined}
                    className={classNames(
                      item.current
                        ? `bg-white text-${brand}-header`
                        : `text-white hover:bg-white hover:text-${brand}-contrast`,
                      `rounded-md px-3 py-2 text-sm font-medium`
                    )}
                  >
                    {item.name}
                  </a>
                ))}
                
              </div>
            </div>
          </div>
          <div className="hidden md:block">
            <div className="ml-6 flex items-center md:ml-8">
              {/* <SignInButton closed={false} status={status} /> */}
              {/* <button
                type="button"
                className="relative rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
              >
                <span className="absolute -inset-1.5" />
                <span className="sr-only">View notifications</span>
                <BellIcon aria-hidden="true" className="size-6" />
              </button> */}

              {/* Profile dropdown */}
              {/* <Menu as="div" className="relative ml-3">
                <div>
                  <MenuButton className="relative flex max-w-xs items-center rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                    <span className="absolute -inset-1.5" />
                    <span className="sr-only">Open user menu</span>
                    <img alt="" src={user.imageUrl} className="size-8 rounded-full" />
                  </MenuButton>
                </div>
                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                  {userNavigation.map((item) => (
                    <MenuItem key={item.name}>
                      <a
                        href={item.href}
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:outline-none"
                      >
                        {item.name}
                      </a>
                    </MenuItem>
                  ))}
                </MenuItems>
              </Menu> */}
            </div>
          </div>
          <div className="flex md:hidden mr-4">
            {/* Mobile menu button */}
            <DisclosureButton className={`group relative inline-flex items-center justify-center rounded-md bg-${brand}-header text-white`}>
              <span className="absolute -inset-0.5" />
              <span className="pr-2">Menu</span>
              <Bars3Icon aria-hidden="true" className="block size-6 group-data-[open]:hidden" />
              <SquareX fill='#FFF' color='#dc0714' aria-hidden="true" className="hidden size-6 group-data-[open]:block" />
            </DisclosureButton>
          </div>
        </div>
      </div>
      <DisclosurePanel className="md:hidden">
        <div className="bg-gpspel-grey-light space-y-1 px-2 pb-3 pt-2 sm:px-3">
          {navigation.map((item) => (
            <DisclosureButton
              key={item.name}
              as="a"
              href={item.href}
              aria-current={item.current ? 'page' : undefined}
              className={classNames(
                item.current ? 'text-default font-extra underline underline-offset-4' : 'hover:font-extra hover:underline hover:underline-offset-4',
                'block rounded-md px-3 py-2 text-base font-medium',
              )}
            >
              {item.name}
            </DisclosureButton>
          ))}
        </div>
        <div className="bg-gpspel-grey-light pb-3">
          <div className="flex items-center px-5">
            {/* <div className="shrink-0">
              <img alt="" src={user.imageUrl} className="size-10 rounded-full" />
            </div>
            <div className="ml-3">
              <div className="text-base/5 font-medium text-white">{user.name}</div>
              <div className="text-sm font-medium text-gray-400">{user.email}</div>
            </div> */}
            {/* <button
              type="button"
              className="relative ml-auto shrink-0 rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
            >
              <span className="absolute -inset-1.5" />
              <span className="sr-only">View notifications</span>
              <BellIcon aria-hidden="true" className="size-6" />
            </button> */}
          </div>
          <div className="mt-3 space-y-1 px-5">
            {/* <SignInButton closed={true} status={status} /> */}
            {/* {userNavigation.map((item) => (
              <DisclosureButton
                key={item.name}
                as="a"
                href={item.href}
                className="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white"
              >
                {item.name}
              </DisclosureButton>
            ))} */}
          </div>
        </div>
      </DisclosurePanel>
    </Disclosure>
)}